module.exports = __webpack_public_path__ + "static/media/gradient-teamble-logo.f08d9deb.png";